import { makeStyles } from "@mui/styles"
import { padding } from "@mui/system"
import { colors } from "../../utils"

const useStyles = makeStyles((theme) => ({
  title: {
    color: colors.white,
    fontWeight: "bold",
  },

  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    backgroundColor: colors.white,
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "28px",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      width: "80%",
      flexDirection: "column-reverse",
    },
  },

  logo: {
    width: "60%",
    margin: "15px 0 0 14px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  logo2: {
    width: "60%",
    margin: "10px 0 0 6px",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  msgContainer: {
    margin: "6% 12%",
    [theme.breakpoints.up("md")]: {
      margin: "6% 18%",
    },
  },

  msg: {
    color: colors.greyStrong,
  },

  box1: {
    [theme.breakpoints.up("md")]: {
      width: "60%",
    },
  },

  box2: {
    [theme.breakpoints.up("md")]: {
      width: "35%",
    },
  },

  okButton: {
    "&.MuiButton-root": {
      backgroundColor: colors.green,
      color: colors.white,
      textTransform: "none",
      "&:hover": {
        backgroundColor: colors.deepGreen,
      },
    },
  },

  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "15px 23px 0",
    marginBottom: "36px",
    [theme.breakpoints.down("md")]: {
      padding: "15px 10px",
      marginBottom: "0",
    },
  },

  createButton: {
    "&.MuiButton-root": {
      textDecoration: "underline",
      fontWeight: "bold",
      textTransform: "none",
    },
  },

  top: {
    background: `linear-gradient( ${colors.deepBlue}, ${colors.deepOceanBlue})`,
    height: "50%",
    margin: "auto 0",
    fontSize: "18px",
  },

  topContent: {
    margin: "auto",
    textAlign: "center",
    padding: "49px 12px 0 12px",
    fontSize: "1em",
    [theme.breakpoints.down("md")]: {
      padding: "49px 12px 12px 12px",
    },
  },

  botContent: {
    color: colors.primary,

    paddingTop: "15px",
    [theme.breakpoints.up("md")]: {
      color: colors.white,
      paddingTop: "30px",
    },
  },

  bot: {
    height: "50%",
    fontSize: "16px",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      background: `linear-gradient( ${colors.oceanBlue}, ${colors.lightBlue})`,
    },
  },

  icon: {
    marginTop: "20px",
    "& .MuiSvgIcon-root": {
      fontSize: "2.5em",
    },
  },

  fields: {
    "&.MuiTypography-root": {
      fontSize: "0.8em",
    },
  },

  date: {
    "&.MuiTypography-root": {
      fontSize: "1em",
      fontWeight: "bold",
    },
  },
}))

export default useStyles
